import { IFormBuilder } from '../IFormBuilder';
import { GenericBaryFormGroup, IGenericBaryFormGroup } from '../GenericBaryFormGroup';
import { FormControl, ValidatorFn } from '@angular/forms';
import { BaryFormFactoryService } from '../../../services/bary-form-factory.service';
import { IContact } from '../../contact.model';
import { Transport } from '../../transport.model';
import { IPricingTransporterConfiguration } from '../../pricing-transporter.configuration';

interface IContactFormBuilder extends IFormBuilder<ContactControls> {
  init(config: IPricingTransporterConfiguration, isPickup: boolean, transport?: Transport): IContactFormBuilder;

  build(): IGenericBaryFormGroup<ContactControls>;
}

export type ContactControls = {
  civility: FormControl;
  firstName: FormControl;
  lastName: FormControl;
  mail: FormControl;
  phone: FormControl;
};

export class ContactFormBuilder implements IContactFormBuilder {
  private formName = 'contactForm';
  private controls?: ContactControls;
  private validators?: ValidatorFn[];

  constructor(private bcf: BaryFormFactoryService) {}

  init(config: IPricingTransporterConfiguration, isPickup = true, transport?: Transport): ContactFormBuilder {
    if (isPickup) {
      this.controls = this.bcf.makePickupContactControls(config, transport);
    } else {
      this.controls = this.bcf.makeDeliveryContactControls(config, transport);
    }
    return this;
  }

  initContact(contact?: IContact): ContactFormBuilder {
    this.controls = this.bcf.makeContactControls(contact);
    return this;
  }

  build(): IGenericBaryFormGroup<ContactControls> {
    return new GenericBaryFormGroup<ContactControls>(this.formName, this.controls!, this.validators);
  }
}
